import {observer} from "mobx-react";
import {FieldDataType} from "../../../../../../generated/api/base";
import {Field} from "../../../../../widgets/form/field/Field";
import {SingleLineLabel} from "../../../../../widgets/input/clicktoedit/datatypes/singleline/SingleLineLabel";
import {SelectInput} from "../../../../../widgets/input/select/SelectInput";
import type {IFieldDataTypeSettingsProps} from "./IFieldDataTypeSettingsProps";

type PeopleFieldVariant = "Single" | "Multiple";
const SelectionModeLabel = "Selection Mode";

export const PeopleFieldSettings = observer((props: IFieldDataTypeSettingsProps) => {
	const {onChange, field} = props;
	const {isVariantSet} = field;

	const onSetVariant = (variant: PeopleFieldVariant) => {
		field.isVariantSet = true;
		field.dataType = variant === "Single" ? FieldDataType.PeopleSingleChoiceList : FieldDataType.PeopleMultipleChoiceList;
		onChange();
	};

	const isInEditMode = !!field.refId;
	const variantLabel = field.dataType === FieldDataType.PeopleSingleChoiceList ? "Single" : "Multiple";

	return (
		<Field
			label={SelectionModeLabel}
			icons={{postLabelIcon: "help"}}
			tooltips={{
				postLabelIconTooltip: "Choose single or multiple user selection for this field. Once created, this cannot be changed.",
			}}
			className="higher"
		>
			{isInEditMode ? (
				<SingleLineLabel value={variantLabel} />
			) : (
				<SelectInput
					selected={isVariantSet ? variantLabel : null}
					options={["Single", "Multiple"] as PeopleFieldVariant[]}
					onChange={onSetVariant}
					placeholder={SelectionModeLabel}
					sort={false}
				/>
			)}
		</Field>
	);
});
